
import axios from '../../axios/index.js'

export default {
  //Bi List
  biReportExpensesList(data) {
    return axios.get('/bi_report/expenses/list', { params: data })
  },
  //Dashboard Accounting
  expensesList(data) {
    return axios.post('/expenses/list', data)
  },
  payExpenses(data) {
    return axios.post('/expenses/payment', data, {
      headers: { 'Content-Type': 'multipart/form-data' },
      processData: false,
      contentType: false
    })
  },
  //Expenses General
  uploadFile(data) {
    return axios.post('expenses/uploadfile', data, {
      headers: { 'Content-Type': 'multipart/form-data' },
      processData: false,
      contentType: false
    })
  },
  taxReturn(data) {
    return axios.post('expenses/taxReturn', data, {
      headers: { 'Content-Type': 'multipart/form-data' },
      processData: false,
      contentType: false
    })
  },
  signedManual(data) {
    return axios.get('expense/signedmanual', { params: data })
  },
  delete(data) {
    return axios.get('expenses/delete', { params: data })
  },
  reject(data) {
    return axios.get('expenses/reject', { params: data })
  },
  rejectClasification(data) {
    return axios.get('expenses/rejectClasification', { params: data })
  },
  pending(data) {
    return axios.get('expenses/pending', { params: data })
  },
  getCompanies(data) {
    return axios.get('expenses/getCompanies', { params: data })
  },
  getStatus(data) {
    return axios.get('expenses/getStatus', { params: data })
  },
  getCategories(data) {
    return axios.get('expenses/getCategories', { params: data })
  },
  search(data) {
    return axios.post('expenses/search', data)
  },
  updateExpenseManual(data){
    return axios.post('expenses/update_expense_manual', data)
  },
  //BOTH
  updateVendorEmail(data) {
    return axios.post('/expense/updateVendorEmail', data)
  },
  update(data) {
    return axios.post('/expense/update', data)
  },
  assignClient(data) {
    return axios.post('expenses/assign', data)
  },
  addComment(data) {
    return axios.post('expenses/addComment', data)
  },
  getComments(data) {
    return axios.get('expenses/getComments', { params: data })
  },
  getFiles(data) {
    return axios.get('expenses/getFiles', { params: data })
  },
  getDetail(data) {
    return axios.get('expense/show', { params: data })
  },
  saveExpense(data) {
    return axios.post('expenses/create', data, {
      headers: { 'Content-Type': 'multipart/form-data' },
      processData: false,
      contentType: false
    })
  },
  createManualExpense(data) {
    return axios.post('expenses/create_manual_expense', data)
  },
  updatePaymentFile(data) {
    return axios.post('/expenses/updatePaymentFile', data,{
      headers: { 'Content-Type': 'multipart/form-data' },
      processData: false,
      contentType: false
    })
  },
  dataToFillExpenseEdit(data){
    return axios.post('expenses/dataToFillExpenseEdit', data)
  },
  updateVendorEmail(data){
    return axios.post('expenses/updateVendorEmail', data)
  },
  deleteFile(data) {
    return axios.post('expenses/deleteFile',data)
  },
  updatePayDate(data){
    return axios.post('expenses/updatePayDate', data)
  },
  getLogs(id) {
    return axios.get('expense/log/message/' + id)
  },
  apportionmentSave(data){
    return axios.post('expense/prorateo',data)
  },
  getDepartaments() {
    return axios.get('budget/assign/departaments')
},
}
